import { ApiType } from "@gymflow/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { productQueryKeys } from "./productQueryKeys";

export function useProductEdit({ api }: { api: ApiType }) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      productId,
      patchedFields,
    }: {
      productId: number;
      patchedFields: { [k: string]: any };
    }) => {
      return (await api.productApi.update(productId, patchedFields)).data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: productQueryKeys.all() });
    },
  });
}
